import { ReactNode, RefObject } from 'react';
import { Box, Stack } from '@rossum/ui/material';

type ViewerFrameProps = {
  header: ReactNode;
  gridTemplateColumns: string;
  containerRef?: RefObject<HTMLDivElement>;
  children: ReactNode;
};

// Shared chrome of the snapshot and diff viewers: header bar + scrollable
// monospace grid.
export const ViewerFrame = ({
  header,
  gridTemplateColumns,
  containerRef,
  children,
}: ViewerFrameProps) => (
  <Stack flex={1} minHeight={0}>
    <Stack
      direction="row"
      alignItems="center"
      sx={{
        px: 2,
        py: 0.5,
        borderBottom: 1,
        borderColor: 'divider',
        bgcolor: 'background.paper',
      }}
    >
      {header}
    </Stack>
    <Box
      ref={containerRef}
      sx={{
        flex: 1,
        minHeight: 0,
        overflow: 'auto',
        bgcolor: 'background.paper',
        fontFamily: "'Roboto Mono Variable', monospace",
        fontSize: 13,
        lineHeight: 1.6,
        display: 'grid',
        gridTemplateColumns,
        alignContent: 'start',
      }}
    >
      {children}
    </Box>
  </Stack>
);
